export const getCountries = () =>
  fetch('/countries.json').then((res) => {
    if (!res.ok) throw new Error('Failed to fetch countries')
    return res.json()
  })
